'use client';
import { objectEntries } from '../object.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _to_primitive(input, hint) {
    if (_type_of(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_type_of(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _to_property_key(arg) {
    var key = _to_primitive(arg, "string");
    return _type_of(key) === "symbol" ? key : String(key);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
/**
 * Убирает вхождения определённых ключей на объекте
 *
 * @param object исходный объект
 * @param keys ключи, которые необходимо отфильтровать
 *
 * @returns копия объекта, без указанных вхождений
 */ function omit(object, keys) {
    if (keys.length <= 0) {
        return _extends({}, object);
    }
    if (keys.length === 1) {
        const [propName] = keys;
        const remaining = _object_without_properties_loose(object, [
            propName
        ].map(_to_property_key));
        return remaining;
    }
    if (!keys.some((key)=>key in object)) {
        return _extends({}, object);
    }
    const asSet = new Set(keys);
    return Object.fromEntries(objectEntries(object).filter(([key])=>!asSet.has(key)));
}

export { omit };
//# sourceMappingURL=omit.js.map
